import { attr, fk, oneToOne } from 'redux-orm';
import { OBJECT_TYPE_SHAPE } from '%paysera_seat_selection/js/seatSelection/config/constants';
import BaseModel from './BaseModel';
import { TYPE_SCENE } from '%paysera_seat_selection/js/seatSelection/constants/shapeTypes';
import singleLabel from '%paysera_seat_selection/js/seatSelection/redux/model/defaults/singleLabel';

class Shape extends BaseModel {
    static modelName = 'Shape';

    static fields = {
        ...BaseModel.fields,
        objectType: attr({ getDefault: () => OBJECT_TYPE_SHAPE }),
        type: attr({ getDefault: () => TYPE_SCENE }),
        label: attr({ getDefault: () => singleLabel }),
        hall: fk('Hall'),
        configuration: oneToOne('Configuration'),
    };
}

export default Shape;
